import styled from 'styled-components';
import { theme } from 'styled-tools';

const ContentCenter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 4rem;

  h1 {
    color: ${theme('colors.orange')};
  }

  p {
    text-align: center;
  }
`;

export { ContentCenter };
